import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './Pages/LandingPage';
import LoginPage from './Pages/LoginPage';
import SignupPage from './Pages/SignupPage';
import Dashboard from './Pages/Dashboard';
import TopicSelectionPage from './Pages/TopicSelectionPage';
import QuizSettingsPage from './Pages/QuizSettingsPage';
import LoadingPageRoadMapNew from './Pages/LoadingPageRoadMapGenerationPage';
import UserKnowledgePage from './Pages/UserKnowlegePage';
import RoadMapPage from './Pages/RoadMapPage';
import BMC from './Pages/BMC';
import QuizPage from './Pages/QuizPage';
import LoadingPageRoadMapCommon from './Pages/RoadMapGenerationLoadingPageCommon';
import AdminDashboard from './Pages/AdminDashboard';
import AdminTopics from './Pages/AdminTopics';
import AdminReport from './Pages/AdminReport';
import Unsubscribe from "./Pages/Unsubscribe"
import CreatedBy from './Pages/CreatedBy';

export default function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route
            path="/select-topic"
            element={<TopicSelectionPage />}
          />
          <Route
            path="/quiz-settings/:topicId/:subTopicId"
            element={<QuizSettingsPage />}
          />
          <Route
            path="/user-knowledge/:roadMapId"
            element={<UserKnowledgePage />}
          />
          <Route path="/quiz/:roadMapId" element={<QuizPage />} />
          <Route
            path="/loading-roadmap/:roadMapId"
            element={<LoadingPageRoadMapNew />}
          />
          <Route
            path="/loading-roadmap-common/:roadMapId"
            element={<LoadingPageRoadMapCommon />}
          />
          <Route
            path="/admin"
            element={<AdminDashboard />}
          />
          <Route
            path="/roadmap/:roadMapId"
            element={<RoadMapPage />}
          />
          <Route
            path="/admin/all-topics"
            element={<AdminTopics />}
          />
          <Route
            path="/admin/report-question"
            element={<AdminReport />}
          />
          <Route path="/bmc" element={<BMC />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/created-by" element={<CreatedBy />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}
